<script setup lang="ts">
import { isIpNotAllowedPostgrestError } from '~/repositories/error'
import { showIpNotAllowedError } from '~/utils/error'

// useAsyncDataWithCaptureを介さないイベントハンドラなどでのAPIリクエスト時の403エラーをハンドリングする
const handleError = (error: unknown) => {
  if (isIpNotAllowedPostgrestError(error)) {
    showIpNotAllowedError()
    return
  }

  throw error
}
</script>

<template>
  <NuxtErrorBoundary @error="handleError">
    <slot />
  </NuxtErrorBoundary>
</template>
